<template>
  <div class="column depending-incidents-list">
    <p v-if="dependingIncidents.length == 0" class="message">
      {{ $t("errors.noDependingEvents") }}
    </p>

    <div
      v-for="dependingIncident in dependingIncidents"
      :key="dependingIncident.mainCondition.id"
      class="depending-incidents-list__item"
    >
      <button-item @click="emit('select', dependingIncident.incident)">
        {{ dependingIncident.incident.title }}
      </button-item>

      <div class="column pl-4">
        <div v-if="dependingIncident.trigger.chance != 100">
          {{ $t("labels.occurrenceProbability") }}{{ $t(":") }}
          {{ dependingIncident.trigger.chance }}%
        </div>

        <div v-if="dependingIncident.trigger.maxOccurrences != null">
          {{ $t("labels.maxOccurrence") }}{{ $t(":") }}
          {{ dependingIncident.trigger.maxOccurrences }}
        </div>

        <div>
          <h4 class="label mt-0">
            {{ $t("objectNames.condition", 1) }}
          </h4>
          <condition-label :condition-id="dependingIncident.mainCondition.id" />
        </div>

        <div v-if="dependingIncident.otherConditions.length > 0">
          <h4 class="label mt-0">
            {{ $t("objectNames.condition", 3) }}
          </h4>
          <ul class="pl-5 mt-0">
            <li
              v-for="condition in dependingIncident.otherConditions"
              :key="condition.id"
            >
              <condition-label :condition-id="condition.id" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import ButtonItem from "@core/input/ButtonItem.vue";
import ConditionLabel from "../condition/ConditionLabel.vue";

import { getDependingIncidents } from "./incidentFunctions";

import type { ActionItem } from "../action/ActionItem";
import type { IncidentItem } from "./IncidentItem";

const props = defineProps<{
  activator: ActionItem | IncidentItem;
}>();

const emit = defineEmits<{
  (event: "select", incident: IncidentItem): void;
}>();

const dependingIncidents = computed(() => {
  return getDependingIncidents(props.activator);
});
</script>

<style lang="scss">
.depending-incidents-list {
  gap: 2rem;
  &__item {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    // padding: 1rem;
    // border: 1px solid var(--color-border-light);
  }
}
</style>
